module.exports = __webpack_public_path__ + "static/media/map_icon.d52ffed6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/map_icon.png
// module id = 1805
// module chunks = 0